import { ReqParams } from "../types";
import axiosInstance from "./axiosInstance";


export default class FeedbackService {
  static async addOrUpdateFeedbackForm(params: ReqParams = {}) {
    const response = await axiosInstance.post("/tenant/survey", params);
    return response.data;
  }

  static async getFeedbackForm(params: ReqParams = {}) {
    const response = await axiosInstance.get("/tenant/survey", { params });
    return response.data;
  }

  static async getFeedbackFormByToken(params: ReqParams = {}) {
    const response = await axiosInstance.get("/customer/validate-feedbackForm", { params });
    return response.data;
  }

  static async submitFeedbackResponse(params: ReqParams = {}) {
    const response = await axiosInstance.post("/customer/feedback?token=" + params.token , params);
    return response.data;
  }


  // static async getFeedbackFormList(params: ReqParams = {}) {
  //   const response = await axiosInstance.get("/tenant/survey", { params });
  //   return response.data;
  // }


  // static async getList(params: ReqParams = {}) {
  //   const response = await axiosInstance.get("/tenant/agents", { params });
  //   return response.data;
  // }


  // static async update(params: ReqParams = {}) {
  //   const response = await axiosInstance.put("/tenant/agents/" + params.id, params);
  //   return response.data;
  // }
}

